import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Analytics from "./components/Analytics";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import SmartStoresPage from "./pages/SmartStoresPage";
import IndustriesPage from "./pages/IndustriesPage";
import BlogPage from "./pages/BlogPage";
import ContactPage from "./pages/ContactPage";
import FloatingWhatsApp from "./components/FloatingWhatsApp";

// AnimatePresence needs access to location, so Routes lives in a child component
function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/"             element={<Home />}            />
        <Route path="/about"        element={<AboutPage />}       />
        <Route path="/services"     element={<ServicesPage />}    />
        <Route path="/smart-stores" element={<SmartStoresPage />} />
        <Route path="/industries"   element={<IndustriesPage />}  />
        <Route path="/blog"         element={<BlogPage />}        />
        <Route path="/contact"      element={<ContactPage />}     />
      </Routes>
    </AnimatePresence>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Analytics />
      <div className="font-poppins overflow-x-hidden">
        <Navbar />
         <FloatingWhatsApp />
        <AnimatedRoutes />
        <Footer />
      </div>
    </BrowserRouter>
  );
}